import React, { FunctionComponent, useState } from "react"
import sortingIcon from "@albelli/photoselector/lib/ImagePicker/Graphic/sorting-icon.svg"
import { locale, DropDown, DropDownItem } from "@albelli/photoselector"

interface SelectYearProps {
  yearsWithPhotos: number[]
  getItems: (obj: any) => void
  setSelectedYear: (number: any) => void
}

interface YearDropDown extends DropDownItem {
  year: number | string
}

const SelectYear: FunctionComponent<SelectYearProps> = ({ getItems, setSelectedYear, yearsWithPhotos }) => {
  const years: YearDropDown[] = yearsWithPhotos.map((year, key) => {
    return { id: key.toString(), title: year.toString(), year: year }
  })
  const title = locale.get().calender.allyears
  years.unshift({ id: "allyear", title: title, year: title })

  const [selected, setSelected] = useState<YearDropDown>(years[0])

  const onSelect = (item: DropDownItem) => {
    const selected = item as YearDropDown
    setSelected(selected)
    setSelectedYear(selected.year)
    getItems({ skip: 0, emptyList: true })
  }

  return (
    <DropDown list={years} selectedId={selected.id} className="year" onSelect={onSelect} position="bottom">
      <div className="photoselector-filter-component year dropdown-label photoselector-sort-value" data-tam="sorting-year">
        <img className="photoselector-dropdown-icon" src={sortingIcon} />
        {selected.title}
      </div>
    </DropDown>
  )
}

export default SelectYear
